
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 511 511","stroke-width":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M462.538 80.462C459.067 53.172 435.717 32 407.5 32h-352C24.897 32 0 56.897 0 87.5v288c0 28.217 21.173 51.566 48.462 55.038C51.933 457.828 75.283 479 103.5 479h352c30.603 0 55.5-24.897 55.5-55.5v-288c0-28.217-21.173-51.566-48.462-55.038zM15 375.5v-288C15 65.168 33.168 47 55.5 47h352c19.768 0 36.264 14.241 39.792 33H103.5c-22.206 0-41.398 13.114-50.263 32H39.5c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h9.151a55.67 55.67 0 00-.651 8.5v279.792c-18.759-3.528-33-20.023-33-39.792zm481 48c0 22.332-18.168 40.5-40.5 40.5h-352C81.168 464 63 445.832 63 423.5v-288C63 113.168 81.168 95 103.5 95h352c22.332 0 40.5 18.168 40.5 40.5v288z"}}),_c('path',{attrs:{"d":"M471.5 160h-384c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h384c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5zM103.5 135a7.51 7.51 0 007.5-7.5 7.51 7.51 0 00-7.5-7.5c-1.97 0-3.91.8-5.3 2.2a7.526 7.526 0 00-2.2 5.3 7.51 7.51 0 007.5 7.5zM167.5 135a7.51 7.51 0 007.5-7.5 7.51 7.51 0 00-7.5-7.5 7.508 7.508 0 00-7.5 7.5 7.512 7.512 0 007.5 7.5zM135.5 135a7.51 7.51 0 007.5-7.5 7.51 7.51 0 00-7.5-7.5 7.508 7.508 0 00-7.5 7.5 7.51 7.51 0 007.5 7.5z"}})])
          )
        }
      }
    